import { Video } from "./video";
import { TextImage } from "./text-image";
import { SponsorsGrid } from "./sponsors-grid";
import { Title } from "./title";
import { Carousel } from "./carousel";
import { Hero } from "./hero";
import { PrismicToLink } from "../utils/prismic-to-link";
import t from "typy";
import { RichText } from "prismic-reactjs";
import { TimelinePreview } from "./timeline-preview";
import { Section } from "./section";
import { useEffect } from "react";
import { Intro } from "./intro";

// A prismic specific component that handles passing the
// Prismic data to "dumber" components
const Slice = ({ slice, idSuffix }) => {
  let Component;
  let scrollToElement;

  useEffect(() => {
    scrollToElement = require("scroll-to-element");
  }, []);

  const scrollToNextSlice = () => {
    if (!scrollToElement) {
      scrollToElement = require("scroll-to-element");
    }

    scrollToElement(`#section-${idSuffix + 1}`, {
      duration: 200,
      ease: "linear"
    });
  };

  switch (slice.slice_type) {
    case "intro": {
      Component = (
        <Intro
          onButtonClick={scrollToNextSlice}
          description={slice.primary.description}
        />
      );
      break;
    }

    case "video": {
      const { poster, youtube_id } = slice.primary;
      const image = t(poster, "url").safeObject;
      const alt = t(poster, "alt").safeObject;
      Component = (
        <Video
          poster={image}
          alt={alt}
          youtube_id={youtube_id}
          onButtonClick={scrollToNextSlice}
        />
      );
      break;
    }
    case "sponsors_grid": {
      Component = (
        <SponsorsGrid title={slice.primary.grid_title} sponsors={slice.items} />
      );
      break;
    }
    case "hero": {
      Component = (
        <Hero
          title={RichText.render(slice.primary.title)}
          description={slice.primary.description}
          onButtonClick={scrollToNextSlice}
        />
      );
      break;
    }
    case "content": {
      const { image, title1, body1 } = slice.primary;
      Component = <Section image={image} title={title1} body={body1} />;
      break;
    }
    case "title": {
      const {
        label_text,
        label_background,
        title1,
        description,
        link
      } = slice.primary;
      Component = (
        <Title
          title={title1}
          label={label_text}
          label_background={label_background}
          link={PrismicToLink(link)}
          description={description}
        />
      );
      break;
    }
    case "carousel": {
      const { items } = slice;
      const slides = items.map(item => item.image);
      Component = (
        <Carousel
          slides={slides}
          onBeforeChange={(current, next) => console.log(current, next)}
        />
      );
      break;
    }
    case "timeline_preview": {
      const { text, button_text, button_link } = slice.primary;
      Component = (
        <TimelinePreview
          text={RichText.render(text)}
          button_text={button_text}
          button_link={PrismicToLink(button_link)}
          nodes={slice.items}
          onButtonClick={scrollToNextSlice}
        />
      );
      break;
    }
    case "image_and_text": {
      const {
        alternate,
        background_image,
        description,
        label,
        title1
      } = slice.primary;
      Component = (
        <TextImage
          alternate={alternate}
          background_image={background_image}
          description={description}
          label={label}
          title={title1}
        />
      );
      break;
    }
  }
  return <div id={`section-${idSuffix}`}>{Component}</div>;
};

export { Slice };
